export const CONFIG = {
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  API_SERVER: process.env.REACT_APP_API_SERVER,
  THEME: process.env.REACT_APP_THEME,
  TOKEN_KEY: 'physioscan-token',
  ANAMNESIS_TYPEFORM_ID: 'FlGjyPDN',
  JITSI_APP_ID: process.env.REACT_APP_JITSI_APP_ID,
};
